import React, { FC, useEffect } from 'react';
import { Box, Divider, makeStyles } from '@material-ui/core';
import EditLayout from 'src/components/editor/EditLayout';
import EditBtnText from 'src/components/editor/EditBtnText';
import EditBtnFontFamily from 'src/components/editor/EditBtnFontFamily';
import EditBtnFont from 'src/components/editor/EditBtnFont';
import EditBtnColor from 'src/components/editor/EditBtnColor';
import EditBtnBgColor from 'src/components/editor/EditBtnBgColor';
import EditMultiOption from 'src/components/editor/EditMultiOption';
import EditOption from 'src/components/editor/EditOption';
import EditRadius from 'src/components/editor/EditRadius';
import EditMultiBranchOption from 'src/components/editor/EditMultiBranchOption';
import EditDeeplink from 'src/components/editor/EditDeeplink';

const useStyles = makeStyles(() => ({
  textFont: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  buttonBgColor: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem'
  }
}));

const Buttons: any = ({ datas }: any) => {
  const classes = useStyles();

  return (
    <Box>
      {datas?.branchType && (
        <>
          <EditMultiBranchOption />
          <Divider />
        </>
      )}
      {datas?.optionText &&
        datas?.optionText?.map((type: any, idx: number) => {
          return (
            type && (
              <div key={idx}>
                <EditMultiOption type={type} />
                <EditOption type={type} />
                <Divider />
              </div>
            )
          );
        })}
      {datas?.btnType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditLayout type={type}>
              {(datas?.btnFontFamily?.[idx] ||
                datas?.btnText?.[idx] ||
                datas?.btnFontSize?.[idx]) && (
                <Box className={classes.textFont}>
                  {datas?.btnFontFamily?.[idx] && (
                    <EditBtnFontFamily type={type} />
                  )}
                  {datas?.btnText?.[idx] && <EditBtnText type={type} />}
                  {datas?.btnFontSize?.[idx] && <EditBtnFont type={type} />}
                </Box>
              )}
              {datas?.btnColor?.[idx] && <EditBtnColor type={type} />}

              {datas?.btnBgColor?.[idx] && (
                <>
                  <Box className={classes.buttonBgColor}>BUTTON COLOR</Box>
                  <EditBtnBgColor type={type} />
                </>
              )}
              {datas?.radius?.[idx] && (
                <>
                  <Box className={classes.buttonBgColor}>BUTTON RADIUS</Box>
                  <EditRadius type={type} max={datas?.radiusMax?.[idx]} />
                </>
              )}
              {datas?.deeplink?.[idx] && (
                <>
                  <Box className={classes.buttonBgColor}>DEEPLINK</Box>
                  <EditDeeplink type={type} />
                </>
              )}
            </EditLayout>
            <Divider />
          </div>
        );
      })}
    </Box>
  );
};

export default Buttons;
